import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { QuestionMarkCircleOutline as Question } from "@styled-icons/evaicons-outline";
import { useState } from "react";
import { GoogleLogin } from "react-google-login";
import { AuthService, encrypt, decrypt } from "../../../../../service";
import Cookies from "js-cookie";
import { AlertError } from "../../../../../component";
import { useEffect } from "react";
import axios from "axios";
import Select from "react-select";
import { useWatch } from "react-hook-form";

const baseURL = process.env.REACT_APP_URL_CLIENT_LANDING;

const AuthenticationSection = ({
  setActiveStep,
  param,
  handleSubmit = () => null,
  register = () => null,
  control,
  serResultOrder,
}) => {
  const [isLogin, setIsLogin] = useState(false);

  const handleOrderQuotation = async ({ body = {}, tokenParam }) => {
    if (tokenParam) {
      try {
        const response = await axios.post(`${baseURL}/order`, body, {
          headers: {
            Authorization: `Bearer ${tokenParam}`,
          },
        });

        if (response.data.data) {
          setActiveStep(4);
          window.localStorage.removeItem("cart");
          serResultOrder(response.data.data);
        } else {
          AlertError({ title: "Error", text: response.data.message });
        }
      } catch (error) {
        // console.log({ error: error.response.data.error });
        AlertError({ title: "Error", text: error.response.data.error });
      }
    }
  };

  if (isLogin) {
    return (
      <FormLogin
        setActiveStep={setActiveStep}
        register={register}
        handleSubmit={handleSubmit}
        param={param}
        handleOrderQuotation={handleOrderQuotation}
        control={control}
      />
    );
  } else {
    return (
      <FormRegistration
        setActiveStep={setActiveStep}
        setIsLogin={setIsLogin}
        param={param}
        control={control}
        handleOrderQuotation={handleOrderQuotation}
      />
    );
  }
};

export default AuthenticationSection;

const FormRegistration = ({
  setIsLogin,
  param,
  control,
  handleOrderQuotation,
}) => {
  const [paramInput, setParamInput] = useState({
    full_name: "",
    phone: "",
    email: "",
    password: "",
    retype_password: "",
    category_company_id: 3,
    company_name: "",
    company_address: "",
    ms_city_id: "",
  });
  const [options, setOptions] = useState({
    company_category: [],
    ms_city: [],
  });
  const body = {
    ...paramInput,
    ms_city_id: paramInput.ms_city_id?.value,
  };
  const btnChangeToLogin = () => setIsLogin(true);

  const request_sender_id = useWatch({
    control,
    name: "request_sender_id",
  });
  const notes = useWatch({
    control,
    name: "notes",
  });

  const handleLogin = async () => {
    try {
      const { data } = await axios.post(`${baseURL}/auth/login`, body);

      if (data.data) {
        const bodyQuot = {
          product_data: param?.cart?.map((item) => ({
            product_id: item.product_id,
            quantity: item.qty,
          })),
          company_id: data?.data?.first_company?.company_id,
          company_name: data?.data?.first_company?.company?.company_name,
          company_address: paramInput.company_address,
          sender_id: request_sender_id,
          notes: notes,
          category_company_name:
            data?.data?.first_company?.company?.category_company
              ?.category_company_name,
        };

        await Cookies.set("token", encrypt(data.data.auth.token), {
          expires: 1,
        });
        await Cookies.set(
          "refreshToken",
          encrypt(data.data.auth.refreshToken),
          {
            expires: 1,
          }
        );
        await Cookies.set("company", encrypt(data.data.first_company), {
          expires: 30,
        });
        await Cookies.set("_id", encrypt(data.data.id), {
          expires: 30,
        });
        if (!Cookies.get("company_id")) {
          await Cookies.set(
            "company_id",
            data.data?.first_company?.company_id
          );
        }

        handleOrderQuotation({
          body: bodyQuot,
          tokenParam: data.data.auth.token,
        });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const btnSendQuotation = async (e) => {
    e.preventDefault();

    try {
      const { data } = await axios.post(`${baseURL}/auth/register`, body);

      if (data.data) {
        handleLogin();
      } else {
        AlertError({ title: "Error", text: data.error });
      }
    } catch (error) {
      console.log({ error });
    }
  };

  const handleOnchangeInput = (e) => {
    setParamInput((state) => ({
      ...state,
      [e.target.name]: e.target.value,
    }));
  };

  const getCompanyCategory = async () => {
    const { data } = await axios.get(`${baseURL}/company/category`);

    if (data.data) {
      setOptions((state) => ({
        ...state,
        company_category: data.data?.map((item) => ({
          value: item.category_company_id,
          label: item.category_company_identifier,
        })),
      }));
    }
  };

  const getMsCity = async () => {
    const { data } = await axios.get(`${baseURL}/ms_city`);

    if (data.data) {
      setOptions((state) => ({
        ...state,
        ms_city: data.data?.map((item) => ({
          value: item.ms_city_id,
          label: item.ms_city_name_full,
        })),
      }));
    }
  };

  useEffect(() => {
    getCompanyCategory();
    getMsCity();
  }, []);
  return (
    <div>
      <h2 className="text-center">Fill Registration</h2>

      <form
        onSubmit={btnSendQuotation}
        className="mt-5 d-flex justify-content-center"
      >
        <div className="row w-50">
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Fullname
              </label>
              <input
                type="text"
                placeholder="Fullname"
                className="form-control"
                name="full_name"
                onChange={handleOnchangeInput}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Whatsapp No.
              </label>
              <input
                type="text"
                placeholder="Whatsapp No."
                className="form-control"
                name="phone"
                onChange={handleOnchangeInput}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Email
              </label>
              <input
                type="email"
                placeholder="email"
                className="form-control"
                name="email"
                onChange={handleOnchangeInput}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Password
              </label>
              <div className="d-flex gap-2">
                <input
                  type="password"
                  placeholder="password"
                  className="form-control"
                  name="password"
                  onChange={handleOnchangeInput}
                />
                <OverlayTrigger
                  placement={"right"}
                  overlay={
                    <Tooltip id={`tooltip-right`}>
                      This password is used for subsequent orders and can be
                      used to login to the DIY (Do It Yourself) advertising
                      platform Mediacartz dashboard page using your registered
                      email and password.
                      <br />
                      <br />
                      you still get easy advertising services through our
                      professional team.
                    </Tooltip>
                  }
                >
                  <Question width={25} />
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Confirm Password
              </label>
              <input
                type="password"
                placeholder="Confirm Password"
                className="form-control"
                name="retype_password"
                onChange={handleOnchangeInput}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Company Type.
              </label>
              <div className="d-flex gap-2">
                <select
                  id=""
                  className="form-select"
                  name="category_company_id"
                  onChange={(e) =>
                    setParamInput((state) => ({
                      ...state,
                      category_company_id: e.target.value,
                    }))
                  }
                >
                  {options.company_category.map((item, idx) => (
                    <option key={idx} value={item.value}>
                      {item.label}
                    </option>
                  ))}
                </select>

                <OverlayTrigger
                  placement={"right"}
                  overlay={
                    <Tooltip id={`tooltip-right`}>
                      <strong>Brand Owner</strong>
                      <br />
                      <span>
                        You buy ads for your own company. we will manage your
                        ads.
                      </span>
                      <br />
                      <br />
                      <strong>Agency</strong>
                      <br />
                      <span>
                        you buy ads for you client company. we can manage your
                        ads or you can manage ads for your clients
                      </span>
                    </Tooltip>
                  }
                >
                  <Question width={25} />
                </OverlayTrigger>
              </div>
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Company Name
              </label>
              <input
                type="text"
                className="form-control"
                placeholder="Company Name"
                name="company_name"
                onChange={handleOnchangeInput}
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                City
              </label>
              <Select
                placeholder="Select City"
                isClearable
                options={options.ms_city}
                onChange={(e) =>
                  setParamInput((state) => ({
                    ...state,
                    ms_city_id: e,
                  }))
                }
              />
            </div>
          </div>
          <div className="col-md-12">
            <div className="mb-2">
              <label htmlFor="" className="form-label">
                Company Address
              </label>
              <textarea
                rows={5}
                type="text"
                className="form-control"
                placeholder="Company Address"
                name="company_address"
                onChange={handleOnchangeInput}
              />
            </div>
          </div>
          <div className="col-md-12 text-center">
            <div className="mb-2 d-flex">
              <button
                className="btn button-primary"
                style={{ width: "100%" }}
                onClick={btnSendQuotation}
                type="submit"
              >
                Send Quotation
              </button>
            </div>
            <button
              className="btn text-center"
              style={{ fontSize: "12px" }}
              onClick={btnChangeToLogin}
            >
              Already registered? Please login here to send the quotation
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

const FormLogin = ({ handleSubmit, param, handleOrderQuotation, control }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false)

  const request_sender_id = useWatch({
    control,
    name: "request_sender_id",
  });
  const notes = useWatch({
    control,
    name: "notes",
  });

  const responseGoogle = async (response) => {
    if (response.tokenId) {
      const body = {
        id_token: response.tokenId,
      };
      await AuthService.loginUserWithGoogle(body).then(async (res) => {
        if (res?.success) {
          const bodyQuot = {
            product_data: param?.cart?.map((item) => ({
              product_id: item.product_id,
              quantity: item.qty,
            })),
            company_id: res?.data?.first_company?.company_id,
            company_name: res?.data?.first_company?.company?.company_name,
            company_address: "",
            sender_id: request_sender_id,
            notes: notes,
            category_company_name:
              res?.data?.first_company?.company?.category_company
                ?.category_company_name,
          };
          if (res.data.auth.token) {
            await handleOrderQuotation({
              body: bodyQuot,
              tokenParam: res.data.auth.token,
            });

            await Cookies.set("token", encrypt(res.data.auth.token), {
              expires: 1,
            });
            await Cookies.set(
              "refreshToken",
              encrypt(res.data.auth.refreshToken),
              {
                expires: 1,
              }
            );
            await Cookies.set("company", encrypt(res.data.first_company), {
              expires: 30,
            });
            await Cookies.set("_id", encrypt(res.data.id), {
              expires: 30,
            });
            if (!Cookies.get("company_id")) {
              await Cookies.set(
                "company_id",
                res.data?.first_company?.company_id
              );
            }
          }
        } else if (res.error) {
          if (res.data) {
          }
          AlertError({ title: "Error", text: res.error });
        }
      });
    }
  };

  const btnLogin = async (e) => {
    setLoading(true)
    try {
      const response = await axios.post(`${baseURL}/auth/login`, {
        email,
        password,
      });

      console.log({ response, e, param });

      if (response?.data) {
        const bodyQuot = {
          product_data: param?.cart?.map((item) => ({
            product_id: item.product_id,
            quantity: item.qty,
          })),
          company_id: response?.data?.data.first_company?.company_id,
          company_name:
            response?.data?.data.first_company?.company?.company_name,
          company_address: "",
          sender_id: e.request_sender_id,
          notes: e.notes,
          category_company_name:
            response?.data?.data.first_company?.company?.category_company
              ?.category_company_name,
        };

        if (response.data.data.auth.token) {
          await handleOrderQuotation({
            body: bodyQuot,
            tokenParam: response.data.data.auth.token,
          });
          setLoading(false)
        }

        await Cookies.set("token", encrypt(response.data.data.auth.token), {
          expires: 1,
        });
        await Cookies.set(
          "refreshToken",
          encrypt(response.data.data.auth.refreshToken),
          {
            expires: 1,
          }
        );
        await Cookies.set("company", encrypt(response.data?.data?.first_company), {
          expires: 30,
        });
        await Cookies.set("_id", encrypt(response.data.data.id), {
          expires: 30,
        });
        if (!Cookies.get("company_id")) {
          await Cookies.set(
            "company_id",
            response.data.data?.first_company?.company_id
          );
        }
      } else {
        // alert(response.error);

        console.log(response.error);
      }

    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <h2 className="text-center">Login To Send Quotation</h2>

      <form
        action=""
        className="d-flex justify-content-center"
        onSubmit={handleSubmit(btnLogin)}
      >
        <div className="container-form w-50">
          <div className="mb-2">
            <label htmlFor="" className="form-label">
              Email
            </label>
            <input
              type="email"
              className="form-control"
              placeholder="Email"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <label htmlFor="" className="form-label">
              Password
            </label>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <button
              className="btn button-primary"
              style={{ width: "100%" }}
              onClick={handleSubmit(btnLogin)}
              type="submit"
              disabled={loading}
            >
              {
                loading ? "Loading" : "Login"
              }
            </button>
          </div>
          <div className="mb-2">
            <button className="btn" style={{ fontSize: "12px" }}>
              Forgot Passowrd? Please Click Here
            </button>
          </div>
          <div className="mb-2">
            <GoogleLogin
              className="button-auth-google"
              clientId={process.env.REACT_APP_CLIENT_ID}
              buttonText="Sign in with Google"
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy={"single_host_origin"}
            />
          </div>
        </div>
      </form>
    </div>
  );
};
